var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GisToolsApi } from '../api/gis-tools-api';
import { ReportsApi } from '../api/reports-api';
export class ReportHelper {
    constructor(gisToolsService, reportsApi) {
        this.gisToolsService = gisToolsService;
        this.reportsApi = reportsApi;
        this.reportErrorMessages = {
            noReportData: 'Unable to load report data at this time. Try reloading the report or contact an administrator for help.'
        };
        /**
         * The list of all possible table names for various data types
         */
        this.tableNames = {
            mpms: [
                'PROJECT_LOCATION_DETAIL_PT',
                'PROJECT_LOCATION_DETAIL_LN_V',
                'PROJECT_LOCATION_DETAIL_LN'
            ],
            bridges: [
                'BRIDGE_ALL_CENTER_PT',
                'BRIDGE_ALL_LN',
                'BRIDGE_LOCAL_CENTER_PT',
                'BRIDGE_LOCAL_LN'
            ],
            hop: [
                'PROJECT_HWY_OCC_PERMITS_PT',
                'PROJECT_HWY_OCC_PERMITS_LN',
                'PROJECT_HWY_OCC_PERMITS_PUB_LN',
                'PROJECT_HWY_OCC_PERMITS_PUB_PT',
                'PROJECT_HWY_OCCUPANCY_PERMITS',
                'PROJECT_HWY_OCCUP_PERMITS_PUB'
            ]
        };
    }
    get mapLayers() {
        let mapLayers = [];
        for (const layer of this.mapRef.map.layers.toArray()) {
            if (layer) {
                if (layer.type === 'group') {
                    mapLayers = this.getLayerGroups(mapLayers, layer);
                }
                else if (layer.type === 'map-image' && layer.mapcoreProps && !layer.mapcoreProps.hideInLegend) {
                    for (const subLayer of layer.sublayers.items) {
                        mapLayers.push(subLayer);
                    }
                }
            }
        }
        return mapLayers;
    }
    setMapRef() {
        return __awaiter(this, void 0, void 0, function* () {
            this.mapRef = document.getElementById('mc-map');
        });
    }
    getLayerGroups(mapLayers, layer) {
        for (const sub of layer.layers) {
            if (sub) {
                if (sub.type === 'map-image') {
                    for (const subLayer of sub.sublayers.items) {
                        mapLayers.push(subLayer);
                    }
                }
                else {
                    mapLayers.push(sub);
                }
            }
        }
        return mapLayers;
    }
    // Get county by name from MapCore
    getCountyNameFromId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.gisToolsService.getCounties([id]);
            return result[0].name;
        });
    }
    // Get municipal name from MapCore
    getMunicipalNameFromId(countyCodes, municipalityCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.gisToolsService.getMunicipalitiesByCounty(countyCodes);
            return result.filter(x => x.municipalityCode === municipalityCode)[0].name;
        });
    }
    // Get congress District name from MapCore
    getCongressionalDistrictByName(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.gisToolsService.getCongressionalDistricts([id]);
            return result[0];
        });
    }
    // Get senate district name from MapCore
    getSenateDistrictByName(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.gisToolsService.getSenateDistricts([id]);
            return result[0];
        });
    }
    // Get House district name from MapCore
    getHouseDistrictByName(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.gisToolsService.getHouseDistricts([id]);
            return result[0];
        });
    }
    getLayerIdByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.gisToolsService.getLayerIdByName([name]);
        });
    }
    // gets all Asset ID's that the report needs contained in visible layers on the map
    getIds(columnName, tables) {
        return __awaiter(this, void 0, void 0, function* () {
            const returnData = [];
            const mapLayers = this.mapLayers && this.mapLayers.length > 0 ? this.mapLayers : [];
            // let paramConfig = this.mapManagerService.getMap().paramConfig;
            // check to see if a layer is visible on map
            for (const layer of mapLayers) {
                // check to see if the layer table matches the list of tables passed in from report
                if (layer.visible === true && this.compareTableArrays(tables, layer.mapcoreProps.tableNames)) {
                    yield this.reportsApi.getVisibleAssetIds(layer.mapcoreProps.parentId, columnName, JSON.parse(layer.source.dataSource.query)).then(layers => {
                        for (const dataArr of layers[0].data) {
                            const id = dataArr[0];
                            if (returnData.indexOf(id) === -1) {
                                returnData.push(id);
                            }
                        }
                    });
                }
            }
            return returnData;
        });
    }
    compareTableArrays(array1, array2) {
        for (const x of array1) {
            const split1 = x.split('.');
            for (const y of array2) {
                const split2 = y.split('.');
                if (split1[split1.length - 1] === split2[split2.length - 1]) {
                    return true;
                }
            }
        }
        return false;
    }
    getBoundaryLayerProperties(legendService) {
        const r = 248;
        const g = 217;
        const b = 28;
        const a = 0.1;
        const polygonSymbol = legendService.getSymbolDefinitionFromGeometry('polygon', [r, g, b, a], [r, g, b]);
        return [polygonSymbol];
    }
}
